import React, { useState } from "react";
import { makeStyles } from "@mui/styles";

import filterItems from "~libs/filterItems";
import SearcherList, {
  SearcherListChangeEvent,
} from "~styled/searcherList/SearcherList";
import ListView from "~styled/listView/ListView";
import getVehiculosUsos from "./getVehiculosUsos";

export interface Uso {
  label: string | null;
  value: string | null;
}

interface VehiculoUsoSelectorProps {
  value: Uso;
  onChange?: (event: { target: { value: Uso } }) => void;
}

const useStyles = makeStyles((theme) => ({
  searcher: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    paddingTop: 10,
    justifyContent: "space-around",
  },
  chip: {
    borderRadius: "6px",
    fontWeight: "bold",
    margin: 2,
  },
}));

const usosList: Uso[] = getVehiculosUsos();

function VehiculoUsoSelector({ value, onChange }: VehiculoUsoSelectorProps) {
  const [filter, setFilter] = useState<string>("");

  const handleItem = (item: Uso) => {
    setFilter("");
    onChange?.({ target: { value: { label: item.label, value: item.value } } });
  };

  const handleFilterChange = (event: SearcherListChangeEvent) => {
    setFilter(event.target.value);
  };

  const classes = useStyles();

  // ListView requiere label: string (no null). Normalizamos:
  type ListItem = { label: string; value: string | null };
  const baseList: Uso[] =
    filter === "" ? usosList : (filterItems(usosList, filter) as Uso[]);
  const listForView: ListItem[] = baseList.map((u) => ({
    label: u.label ?? "",
    value: u.value ?? null,
  }));

  return (
    <>
      <div className={classes.searcher}>
        <SearcherList
          onClear={() => handleItem({ value: null, label: null })}
          filter={filter}
          onChange={handleFilterChange}
          placeholder={"Buscar uso"}
        />
        <ListView onItemSelected={handleItem} list={listForView} />
      </div>
    </>
  );
}

export default React.memo(VehiculoUsoSelector);
